import React from 'react';
import '../styles/DisclaimerModal.css';

/**
 * DisclaimerModal
 * Props:
 *   open      {boolean}  — controls visibility
 *   mode      {'camera'|'file'}  — adjusts copy
 *   onAccept  {() => void}
 *   onDecline {() => void}
 */
export default function DisclaimerModal({ open, mode = 'camera', onAccept, onDecline }) {
  if (!open) return null;

  const isCamera = mode === 'camera';

  return (
    <div className="disc-overlay" role="dialog" aria-modal="true" aria-labelledby="disc-title">
      <div className="disc-card">
        {/* Icon */}
        <div className="disc-icon-wrap">
          {isCamera ? (
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
              <circle cx="12" cy="13" r="4"/>
            </svg>
          ) : (
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
          )}
        </div>

        <h2 id="disc-title" className="disc-title">
          {isCamera ? 'Camera Access' : 'Photo Upload'}
        </h2>

        <p className="disc-body">
          {isCamera
            ? 'Nyafaz requires access to your camera to capture a photo. Your camera feed is processed locally — no video is recorded, stored, or transmitted.'
            : 'The photo you upload will be sent to our AI processing server to detect and colour your hair. It is used only for this session and is not stored permanently.'}
        </p>

        <ul className="disc-list">
          <li>Images are processed in an isolated session</li>
          <li>No data is shared with third parties</li>
          <li>You can delete your session at any time</li>
        </ul>

        <div className="disc-actions">
          <button className="disc-btn-decline" onClick={onDecline}>
            Decline
          </button>
          <button className="disc-btn-accept" onClick={onAccept}>
            {isCamera ? 'Allow Camera' : 'Proceed'}
          </button>
        </div>
      </div>
    </div>
  );
}
